var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6001 10.2273C19.6001 9.51825 19.5365 8.83643 19.4183 8.18188H10.0001V12.0501H15.382C15.1501 13.3001 14.4456 14.3592 13.3865 15.0683V17.5774H16.6183C18.5092 15.8364 19.6001 13.2728 19.6001 10.2273Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99937 20.0002C12.6994 20.0002 14.963 19.1047 16.6176 17.5774L13.3857 15.0683C12.4903 15.6683 11.3448 16.0229 9.99937 16.0229C7.39482 16.0229 5.19027 14.2638 4.4039 11.9001H1.06299V14.4911C2.70845 17.7593 6.09027 20.0002 9.99937 20.0002Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40456 11.9C4.20456 11.3 4.09092 10.659 4.09092 9.99995C4.09092 9.34086 4.20456 8.69995 4.40456 8.09995V5.50903H1.06364C0.386365 6.85904 0 8.38631 0 9.99995C0 11.6136 0.386365 13.1409 1.06364 14.4909L4.40456 11.9Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99937 3.97728C11.4676 3.97728 12.7857 4.48183 13.8221 5.47274L16.6903 2.60455C14.9585 0.990911 12.6948 0 9.99937 0C6.09027 0 2.70845 2.24091 1.06299 5.5091L4.4039 8.10002C5.19027 5.73638 7.39482 3.97728 9.99937 3.97728Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.6f2f6a2fc3a8942af6e5d6b563840b88.svg";
export { ForwardRef as ReactComponent };